import React, { useContext } from 'react'
import { FirebaseContext } from '../firebase'
import firebase from 'firebase'
import { Button } from 'react-bootstrap'
import { useHistory } from 'react-router-dom'

function FavoriteBtn({sequence, size = "md", styleClasses = ""}) {

    const {fire, user} = useContext(FirebaseContext)
    const history = useHistory()

    function markFavorite(sequenceId) {
        fire.firestore().collection('sequences').doc(sequenceId)
            .update({
                favoritedBy: firebase.firestore.FieldValue.arrayUnion(user.uid)
            })
    }

    function removeFavorite(sequenceId) {
        fire.firestore().collection('sequences').doc(sequenceId)
            .update({
                favoritedBy: firebase.firestore.FieldValue.arrayRemove(user.uid)
            })
    }

    if (!user) {
        return (
            <Button size={size} variant="light" className={`favorite ${styleClasses}`} onClick={() => history.push("/login")}>
                <i className="ri-heart-line ri-lg "></i>
            </Button>
        )
    } else if (sequence.favoritedBy && sequence.favoritedBy.includes(user.uid)) {
        return (
            <Button size={size} variant="light" className={`favorite ${styleClasses}`} onClick={() => removeFavorite(sequence.id)}>
                <i className="ri-heart-fill ri-lg text-danger"></i>
            </Button>
        )

    } else {
        return (
            <Button size={size} variant="light" className={`favorite ${styleClasses}`} onClick={() => markFavorite(sequence.id)}>
                <i className="ri-heart-line ri-lg"></i>
            </Button>
        )
    }
}

export default FavoriteBtn